
import {ElLoading} from "element-plus";

const columnList: Array<column> = [
    {
        prop: "order_sn",
        label: "工单号",
        width: 66,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 66,
    },
    {
        prop: "car_code",
        label: "车牌号",
        width: 66,
    },
    {
        prop: "car_name",
        label: "车型",
        width: 66,
    },
    {
        prop: "name",
        label: "配件",
        width: 66,
    },
    {
        prop: "construct_name",
        label: "施工人",
        width: 66,
    },
    {
        prop: "branch_name",
        label: "部门",
        width: 66,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 66,
    },
    {
        prop: "output_value",
        label: "销售价",
        width: 66,
    },
    {
        prop: "num",
        label: "数量",
        width: 66,
    },

    {
        prop: "offer_price",
        label: "报价金额",
        width: 66,
    },
    {
        prop: "sum_output_value",
        label: "销售金额",
        width: 66,
    },
    {
        prop: "build_num",
        label: "施工人数",
        width: 66,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 66,
    },
    // {
    //     prop: "parts_cost",
    //     label: "成本",
    //     width: 66,
    // },
    {
        prop: "build_yj",
        label: "业绩",
        width: 66,
    },
    {
        prop: "build_bonus_price",
        label: "提成",
        width: 66,
    },
];
import { Request } from "@/api/request";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getPurchaseTable,
    getSupplierList,
    partsConstructionExport,
    projectConstructionExport,
    totalExport
} from "@/api/http";
import { column } from "@/assets/types/common";
import { accAdd } from "@/api/api";
import {getFirstNowLastDay} from "@/api/date";

export default defineComponent({
    name: "PartsConstruction",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["配件施工明细"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter = reactive({
                time: [getFirstNowLastDay()[0],getFirstNowLastDay()[1]],
                page: currentPage.value,
                pagesize: pageSize.value,
                search: "",
                status: "1",
                start_time: null,
                end_time: null,
                parts_id: null,
                project_id: null,
                constructor_id: null,
            } as any),
            dialog_show = ref(false),
            form_isload = ref(false),
            form = ref({
                name: "",
                phone: "",
                nickname: "",
                position_id: "",
                branch_id: "",
                role_id: "",
                gender: "",
                qq: "",
                wechat: "",
                email: "",
                identity_number: "",
                address: "",
                entry_time: "",
            } as any),
            selectList = ref({
                parts: [],
                branch: [],
                staff: [],
            } as any),
            formRef = ref(null),
            formRules = {
                name: [{ required: true, message: "必填", trigger: "blur" }],
                role_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                gender: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                nickname: [
                    { required: true, message: "必填", trigger: "blur" },
                ],
                position_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
                branch_id: [
                    { required: true, message: "必填", trigger: "changle" },
                ],
            },
            form_positionList = ref([]),
            form_branchList = ref([]),
            form_roleList = ref([]),
            _addstaff = (): void => {
                dialog_show.value = true;
                form_isload.value = true;

                Request.axiosInstance({
                    url: "adminapi/Position/list",
                    data: { status: 1 },
                }).then((res: any) => {
                    form_positionList.value = res?.content?.list || [];
                    Request.axiosInstance({
                        url: "adminapi/Role/list",
                    }).then((res: any) => {
                        form_roleList.value = res?.content?.list || [];
                        form_isload.value = false;
                    });
                });
            },
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
                let start_time = screenParameter.time?Math.floor(new Date(screenParameter.time[0]).getTime()/1000):"";
                let end_time = screenParameter.time ?Math.floor((new Date(screenParameter.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                projectConstructionExport({...screenParameter,start_time:start_time,end_time:end_time,type:2}).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            screenChange = (e: any, key: any): void => {
                getTableData();
            },
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                let start_time = screenParameter.time?Math.floor(new Date(screenParameter.time[0]).getTime()/1000):"";
                let end_time = screenParameter.time ?Math.floor((new Date(screenParameter.time[1]).getTime()+24*60*60*1000-1)/1000):"";
                let data = {...screenParameter,start_time:start_time,end_time:end_time,type:2,page:currentPage.value,pagesize:pageSize.value};
                Request.axiosInstance({
                    url: "adminapi/ConstructionOrder/projectConstructionlist",
                    data,
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    selectList.value.total_outputvalue = res?.content?.total_outputvalue;
                    selectList.value.total_yj = res?.content?.total_yj;
                    selectList.value.total_commission = res?.content?.total_commission;
                    //selectList.value.total_sum_cost_price = res?.content?.total_sum_cost_price;
                    console.log(selectList.value);
                });
            },
            selectChange = (e: number): void => {
                // console.log(e);
                getTableData();
            },
            getSummaries = (param: any): any => {
                const { columns, data } = param;
                const sums: any = [];
                const propArr = [
                    "output_value",
                    "build_yj",
                    "build_bonus_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "output_value") {
                            sums[index] = selectList.value.total_outputvalue;
                        } else if (column.property == "build_yj") {
                            sums[index] = selectList.value.total_yj;
                        } else if (column.property == "build_bonus_price") {
                            sums[index] = selectList.value.total_commission;
                        }
                        // else if (column.property == "parts_cost") {
                        //     sums[index] = selectList.value.total_sum_cost_price;
                        // }
                        if(column.property == "number"){
                            sums[index] = `${sums[index]}`;
                        }else{
                            sums[index] = `¥${sums[index]}`;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;

            };

        onMounted(() => {
            Promise.all([
                Request.axiosInstance({
                    url: "adminapi/Mountings/totalList",
                    data: { status: 1 },
                }),
                Request.axiosInstance({
                    url: "adminapi/OrderCar/constructors",
                }),
            ]).then((res: any) => {
                selectList.value.parts = res[0]?.content?.list || [];
                selectList.value.staff = res[1]?.content?.staff || [];
                selectList.value.branch = res[1]?.content?.branch || [];
                getTableData();
            });
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            total,
			pageSize,
			currentPage,
			handleSizeChange,
			handleCurrentChange,
            screen,
            screenParameter,
            selectChange,
            dialog_show,
            form,
            formRef,
            formRules,
            form_isload,
            form_positionList,
            form_branchList,
            form_roleList,
            _addstaff,
            screenChange,
            selectList,
            getSummaries,
            exportChange
        };
    },
});
